import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { initTelemetry } from "./lib/telemetry";
import "./styles.css";
import "./constellation.css";

if ("scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

const params = new URLSearchParams(window.location.search);
const redirect = params.get("redirect");

if (redirect) {
  window.history.replaceState(null, "", redirect);
}

initTelemetry();

const app = (
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

const root = document.getElementById("root");
const currentPath = window.location.pathname.replace(/\/+$/, "") || "/";
if (root.dataset.prerenderPath === currentPath) {
  ReactDOM.hydrateRoot(root, app);
} else {
  // Development, unknown URLs and redirect recovery have no matching server tree.
  ReactDOM.createRoot(root).render(app);
}
